// src/App.js
import AuthGate      from "./auth/AuthGate";
import TokenProvider from "./payments/TokenProvider";
import WritingCoach  from "./WritingCoach";

export default function App() {
  return (
    <AuthGate>
      <TokenProvider>
        <WritingCoach />
      </TokenProvider>
    </AuthGate>
  );
}
